"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var Hero = function Hero(_ref) {
  var left = _ref.left,
    children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full w-full"
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "hidden md:block w-1/2 xl:w-1/3 bg-center bg-cover",
    style: {
      backgroundColor: '#2477f1',
      backgroundImage: "url('".concat(t('onboarding-side-bg.png'), "')")
    }
  }, left), /*#__PURE__*/_react["default"].createElement("section", {
    className: "w-full md:w-2/3 overflow-auto"
  }, children));
};
var _default = exports["default"] = Hero;
//# sourceMappingURL=index.js.map